import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';
/**
 *   查询应用版本列表
 * @method getVersionList
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getVersionList(params) {
  return request({
    url: `/op/cunwappupgrades/page`,
    method: 'get',
    params: params
  });
}

/**
 *   根据packageName获取升级详情
 * @method getUpgradeAppDetail
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getVersionDetail(packageName) {
  return request({
    url: `/op/cunwappupgrades/info`,
    method: 'get',
    params: { packageName }
  });
}

/**
 *   创建升级应用版本
 * @method addApplicationVersion
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function addApplicationVersion(form) {
  return request({
    url: `/op/cunwappupgrades/`,
    method: 'post',
    data: form
  });
}

/**
 *   删除/禁用/启用应用升级
 * @method updateApplicationUpgradeStatus
 * @param  form
 * @return { request } axsio请求封装
 */
export function updateApplicationUpgradeStatus(form) {
  return request({
    url: `/op/cunwappupgrades/batch-status`,
    method: 'post',
    data: form
  });
}

/**
 *  编辑升级应用版本信息
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplicationVersion(id, form) {
  return request({
    url: `/op/cunwappupgrades/${id}`,
    method: 'post',
    data: form
  });
}
/**
 *  发布升级应用版本信息
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestask(form) {
  return request({
    url: `/op/cunwappupgradestask/`,
    method: 'post',
    data: form
  });
}
/**
 *  查询发布版本信息(历史记录)
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappStatistical(form) {
  return request({
    url: `/op/cunwappupgradestask/statistical`,
    method: 'get',
    params: form
  });
}
/**
 *  查询发布版本信息(历史记录)
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestaskHistory(form) {
  return request({
    url: `/op/cunwappupgradestask/page`,
    method: 'get',
    params: form
  });
}

/**
 *  查询应用版本设备绑定跟新列表（失败记录）
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestaskAppdevice(form) {
  return request({
    url: `/op/cunwappupgradestask/appdevice`,
    method: 'get',
    params: form
  });
}
/**
 *  导出班级失败列表信息
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestaskClassExcel(form) {
  return request({
    url: `/op/cunwappupgradestask/class/excel`,
    method: 'get',
    params: form
  });
}
/**
 *  导出教室失败列表信息
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestaskRoomExcel(form) {
  return request({
    url: `/op/cunwappupgradestask/room/excel`,
    method: 'get',
    params: form
  });
}
/**
 *  查询应用版本发布详情列表（查看详情）
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function cunwappupgradestaskDetail(form) {
  return request({
    url: `/op/cunwappupgradestask/taskdetail/page`,
    method: 'get',
    params: form
  });
}

// 需求2.0 校园应用版本管理

// 查询校园应用版本分页列表
export function getAppVersionList(params) {
  return request({
    url: `/campus/app/versions/page`,
    method: 'get',
    params: params
  });
}
// 查询校园应用最新版本分页列表
export function getAppVersionLatestList(params) {
  return request({
    url: `/campus/app/versions/latest/page`,
    method: 'get',
    params
  });
}
// 根据code获取查询应用
export function getApplicationByCode(params) {
  return request({
    url: `/campus/apps/code/${params.code}`,
    method: 'get',
    params
  });
}
// 根据id获取版本信息
export function getVersionById(id, params) {
  return request({
    url: `/campus/app/versions/${id}`,
    method: 'get',
    params
  });
}
// 更新版本详细信息
export function updateVersion(id, data) {
  return request({
    url: `/campus/app/versions/${id}`,
    method: 'put',
    data
  });
}
// 创建版本信息
export function addVersion(data) {
  return request({
    url: `/campus/app/versions/`,
    method: 'post',
    data
  });
}
// 校园版本-禁用
export function campusVersionsDisable(params) {
  return request({
    url: `/campus/app/versions/disable`,
    method: 'PUT',
    params
  });
}
// 校园版本-启用
export function campusVersionsEnable(params) {
  return request({
    url: `/campus/app/versions/enable`,
    method: 'PUT',
    params
  });
}
// 删除校园应用版本
export function deleteVersion(params) {
  return request({
    url: `/campus/app/versions/`,
    method: 'delete',
    params
  });
}

// 需求2.0
// 发布版本
export function campusVersionsRelease(id, data) {
  return request({
    url: `/campus/app/versions/release/${id}`,
    method: 'put',
    data
  });
}
// 统计校园应用版本发布设备数
export function campusVersionsReleaseStatistic(params) {
  return request({
    url: `/campus/app/versions/release/statistic`,
    method: 'get',
    params
  });
}
// 查询校园应用版本发布统计分页列表
export function campusVersionsReleaseStatisticPage(params) {
  return request({
    url: `/campus/app/versions/release/statistic/page`,
    method: 'get',
    params
  });
}
// 查询校园应用版本未升级设备列表
export function campusVersionsReleaseUnupgradeList(params) {
  return request({
    url: `/campus/app/versions/unupgrade/list`,
    method: 'get',
    params
  });
}
// 查询校园应用版本升级失败设备列表
export function campusVersionsReleaseUpgradeList(params) {
  return request({
    url: `/campus/app/versions/upgrade/list`,
    method: 'get',
    params
  });
}
// 版本管理 导出校园应用版本未升级设备列表
export function campusVersionUnupgradeExport(params) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}/campus/app/versions/unupgrade/export?`;
  for (var key in params) {
    url += `${key}=${params[key]}&`;
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}
// 版本管理 导出校园应用版本升级设备列表
export function campusVersionUpgradeExport(params) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}/campus/app/versions/upgrade/export?`;
  for (var key in params) {
    url += `${key}=${params[key]}&`;
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}

